import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Text, Button, Heading2 } from '@blueprint/ui';

export const Wrapper = styled('div')(({ theme: { mediaQueries } }) => {
    return css`
        width: 100%;
        display: flex;
        flex-direction: column;

        ${mediaQueries.large} {
            margin-left: 12px;
            max-width: 721px;
        }
    `;
});

export const Image = styled('img')(({ theme: { mediaQueries } }) => {
    return css`
        display: flex;

        ${mediaQueries.large} {
            width: 100%;
        }
    `;
});

export const MainContent = styled('div')(
    ({ theme: { mediaQueries, spacing } }) => {
        return css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: ${spacing['16px']};

            ${mediaQueries.large} {
                padding: ${spacing['24px']};
                width: 75%;
            }
        `;
    }
);

export const Heading = styled(Heading2)(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['24px']};
    `;
});

export const Preamble = styled(Text)(({ theme: { spacing, mediaQueries } }) => {
    return css`
        margin-bottom: ${spacing['8px']};

        ${mediaQueries.large} {
            margin-bottom: ${spacing['16px']};
        }

        ${mediaQueries.extraLarge} {
            margin-bottom: ${spacing['24px']};
        }
    `;
});

export const ReasonToJoin = styled(Text)(
    ({ theme: { spacing, mediaQueries } }) => {
        return css`
            margin-bottom: ${spacing['8px']};

            ${mediaQueries.large} {
                margin-bottom: ${spacing['16px']};
            }

            ${mediaQueries.extraLarge} {
                margin-bottom: ${spacing['24px']};
            }
        `;
    }
);

export const ButtonsWrapper = styled('div')(
    ({ theme: { mediaQueries, spacing } }) => {
        return css`
            display: flex;
            width: 100%;
            justify-content: space-around;
            margin-top: ${spacing['16px']};

            ${mediaQueries.medium} {
                margin-top: 0;
            }

            ${mediaQueries.large} {
                justify-content: center;
            }
        `;
    }
);

export const RegAndLoginButton = styled(Button)(
    ({ theme: { spacing, mediaQueries } }) => {
        return css`
            width: 100%;
            max-width: 180px;
            height: ${spacing['48px']};
            display: flex;
            border-radius: ${spacing['4px']};
            margin-left: 0;
            margin-right: 0;

            ${mediaQueries.large} {
                margin-left: ${spacing['4px']};
                margin-right: ${spacing['4px']};
            }
        `;
    }
);
